export default __webpack_public_path__ + "cd4359137880138f531f58f2a2a47119.png";